"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iCreate = void 0;
const t = require("io-ts");
const UserGroup = require("./userGroup");
const File = require("./file");
exports.iCreate = t.intersection([
    File.iCreateFolderRequiredParams,
    t.interface({
        type: t.literal('SUBPROJECT'),
        categories: t.array(UserGroup.iUserGroup),
        folders: t.interface({
            ids: t.array(t.number),
            excluded: t.array(t.number)
        }),
        customMeta: File.iSimplifiedCustomMetadata,
        notify: t.array(t.string)
    })
]);
//# sourceMappingURL=subproject.js.map